import React from "react";
import PartsTable from "./Tables/PartsTable";
import "./BOMTable.css";

const HEADING_TO_TABLE_GAP = "14px";

/**
 * BOMTable Component
 * 
 * Displays the Bill of Materials (BOM) table for a document
 * Uses shared PartsTable component with automatic sorting
 * 
 * @param {string} type - The type/name for the BOM heading
 * @param {Array} bomTable - Array of BOM items
 */
const BOMTable = ({
  type,
  bomTable = [],
  showAdjustQtyButton = false,
  onAdjustQtyClick,
  totalQtyToBuild = null,
}) => {
  return (
    <>
      {/* BOM Table */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <h3 style={{ margin: 0 }}>{type} BOM</h3>
        {showAdjustQtyButton && (
          <button
            type="button"
            className="bom-adjust-qty-btn"
            onClick={onAdjustQtyClick}
          >
            Adjust QTY
          </button>
        )}
      </div>
      <div style={{ marginTop: HEADING_TO_TABLE_GAP }}>
        <PartsTable
          data={bomTable}
          dataFormat="bom"
          autoSort={true}
          hideZeroQty={false}
          totalQtyToBuild={totalQtyToBuild}
        />
      </div>
    </>
  );
};

export default BOMTable;
